<div *ngIf="!loading" appModal (closeModal)="close()" [mainClass]="'lg-modal'">
  <section class="order-modal">
    <section class="modal-title-container flex flex-col justify-center items-center">
      <h2 class="modal--title mb-5 text-charcoal">Order #{{ receipt?.orderNo }}</h2>
      <span>Ordered on {{ receipt?.createdAt | date: 'MMM dd, y' }}</span>
    </section>
    <section class="modal-content-container order-modal__content">
      <article class="order-modal__purchase">
        <div class="order-modal__purchase--wrapper">
          <h3 class="mb-10 text-charcoal">Your purchase</h3>
          <div *ngFor="let event of receipt.eventDetails" class="flex items-center">
            <img
              [src]="event?.eventLogo || purchaseLogo"
              [alt]="event?.eventName"
              class="event__avatar logo-bg mr-10"
            />
            <span>
              <div class="font-bold mb-4">{{ event?.product }}</div>
              <div class="mb-4 text-base">{{ event?.eventName }}</div>
              <div class="text-base">
                {{ event?.athlete }}{{ event.athlete && (event.gradYear || event.teamName) ? ', ' : '' }}
                {{ event?.gradYear }}{{ event.gradYear && event.teamName ? ', ' : '' }}{{ event?.teamName }}
              </div>
            </span>
          </div>
        </div>
        <div class="fade"></div>
      </article>

      <article class="order-modal__payment">
        <h4 class="mb-10 text-charcoal">Payment information</h4>
        <div class="flex items-center">
          <img
            *ngIf="receipt.cardImage"
            [src]="receipt?.cardImage"
            alt="Credit Card Image"
            class="event__avatar logo-bg mr-10"
          />
          <span>
            <div>{{ receipt?.cardholderName }}</div>
            <div *ngIf="receipt?.paymentMethod && receipt?.cardNumberLast4Digits && receipt?.cardExpirationDate">
              {{ receipt?.paymentMethod }} ending in <span class="font-bold">{{ receipt?.cardNumberLast4Digits }}</span
              >&nbsp;&nbsp; Exp date:
              <span class="font-bold">{{ receipt?.cardExpirationDate }}</span>
            </div>
          </span>
        </div>
      </article>
      <article class="order-modal__summary">
        <h3 class="mb-30 text-charcoal">Order Summary</h3>
        <div class="flex justify-between mb-23">
          <span>Subtotal</span> <span>${{ receipt.subtotal ? receipt.subtotal : 0 }}</span>
        </div>
        <div class="flex justify-between mb-10">
          <span>Processing Fee</span>
          <span>${{ receipt.processingFee ? receipt.processingFee : 0 }}</span>
        </div>
        <div *ngIf="receipt.initialPrice" class="my-10">
          <div class="flex justify-between items-center px-10 order-modal--coupon">
            <span>Coupon Code </span>
            <span>${{ receipt.couponTotal }}</span>
          </div>
        </div>
        <div class="flex justify-between mt-20 font-bold">
          <span>Total</span> <span>${{ receipt.total ? receipt.total : 0 }}</span>
        </div>
        <div *ngIf="receipt.refundTotal" class="my-10">
          <div class="flex justify-between-center-vert px-10 order-modal--coupon">
            <span>Refunded </span>
            <span>-${{ receipt.refundTotal }}</span>
          </div>
        </div>
      </article>
    </section>
    <section class="modal-actions-container">
      <button class="btn btn-lg" (click)="close()">Done</button>
    </section>
  </section>
</div>
